function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "M1 4.75h7v1H1zM15 10.75H8v1h7z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 5.25c0 .429-.23.855-.679 1.191C13.373 6.777 12.731 7 12 7c-.73 0-1.373-.223-1.821-.559C9.73 6.105 9.5 5.679 9.5 5.25c0-.429.23-.855.679-1.191.448-.336 1.09-.559 1.821-.559.73 0 1.373.223 1.821.559.449.336.679.762.679 1.191zM6.5 11.25c0 .429-.23.855-.679 1.191C5.373 12.777 4.731 13 4 13c-.73 0-1.373-.223-1.821-.559-.448-.336-.679-.762-.679-1.191 0-.429.23-.855.679-1.191C2.627 9.723 3.269 9.5 4 9.5c.73 0 1.373.223 1.821.559.449.336.679.762.679 1.191z",
  stroke: "#FCFCFC"
});
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgFilter;